import React from "react";
import {
    RadioGroup,
    Radio,
    FormControlLabel,
    TextField,
    Select,
    MenuItem,
    Typography,
} from "@material-ui/core";
import { ErrorMessage } from "formik";

const ParentsDetails = (props) => {
    return(
        <div className="form-section-root">
            <div className="form-row form-header-row">
                <div className="form-group">
                    <Typography className="normal-text">
                        <b>PARENTS DETAILS</b>
                    </Typography>
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-25 radio-div">
                    <label>Mother is single parent?</label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.parentsDetails.singleParent}
                        name="parentsDetails.singleParent"
                        onChange={e => { props.setFieldValue("parentsDetails.singleParent", e.target.value) }}
                    >
                        <FormControlLabel
                            value="1"
                            label="Yes"
                            control={<Radio color="secondary" />}
                        />
                        <FormControlLabel
                            value="0"
                            label="No"
                            control={<Radio color="secondary" />}
                        />
                    </RadioGroup>
                </div>
                <div className="form-group text-inp col-25">
                    <label>Father's First Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.fatherFirstName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.fatherFirstName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.fatherFirstName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Father's Middle Name</label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.fatherMiddleName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.fatherMiddleName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.fatherMiddleName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Father's Last Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.fatherLastName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.fatherLastName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.fatherLastName", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-25"></div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Father's First Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterFatherFirstName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterFatherFirstName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterFatherFirstName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Father's Middle Name</label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterFatherMiddleName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterFatherMiddleName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterFatherMiddleName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Father's Last Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterFatherLastName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterFatherLastName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterFatherLastName", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-25"></div>
                <div className="form-group text-inp col-25">
                    <label>Mother's First Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.motherFirstName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.motherFirstName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.motherFirstName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Mother's Middle Name</label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.motherMiddleName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.motherMiddleName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.motherMiddleName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Mother's Last Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.motherLastName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.motherLastName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.motherLastName", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-25"></div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Mother's First Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterMotherFirstName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterMotherFirstName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterMotherFirstName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Mother's Middle Name</label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterMotherMiddleName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterMotherMiddleName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterMotherMiddleName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Re-enter Mother's Last Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.parentsDetails.reEnterMotherLastName}
                        color="secondary"
                        variant="outlined"
                        name="parentsDetails.reEnterMotherLastName"
                        onChange={e => {
                            props.setFieldValue("parentsDetails.reEnterMotherLastName", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-50 radio-div">
                    <label>Parent name to be printed on PAN</label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.parentsDetails.parentNamePrint}
                        name="parentsDetails.parentNamePrint"
                        onChange={e => { props.setFieldValue("parentsDetails.parentNamePrint", e.target.value) }}
                    >
                        <FormControlLabel
                            value="F"
                            label="Father's name"
                            control={<Radio color="secondary" />}
                        />
                        <FormControlLabel
                            value="M"
                            label="Mother's name"
                            control={<Radio color="secondary" />}
                        />
                    </RadioGroup>
                </div>
            </div>
        </div>
    );
};

export default ParentsDetails;

const Imp = () => <span className="imp">*</span>;
